import { Button, Layout, Typography } from "matsuri-ui"
import styled from "@emotion/styled"
import CloseIcon from "@mui/icons-material/Close"
import { ReactNode } from "react"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { Header } from "@/components/Header/Header"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { theme } from "@/theme"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"

const PageTitle = styled.div`
    font-size: 20px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
    margin-top: 30vh;
    text-align: center;
`

const BodyText = styled.div`
    font-size: 16px;
    color: ${theme.palette.intentions.text.primary};
    text-align: center;
    margin-top: 16px;
`

const SealImage = styled.img`
    display: block;
    margin: 96px auto 16px auto;
    max-width: 138px;
    height: auto;
`

export const ConfirmLayout = (props: {
    headerTitle?: string
    onNext?: () => void
    title: string
    titleSecondLine?: string
    sealImageSrc?: string
    primaryButtonLabel: string
    cancelButtonLabel?: string
    cancelErrorColor?: boolean
    tertiaryButtonLabel?: string
    tertiaryErrorColor?: boolean
    next: () => void
    cancel?: () => void
    tertiary?: () => void
    children?: ReactNode
}) => {
    const { rootProps, headerProps, bodyProps, footerProps } =
        useMobileLayoutProps()

    return (
        <main {...rootProps}>
            {props.headerTitle && (
                <Header {...headerProps}>
                    <MobileAppHeader
                        title={
                            <Typography variant="h4">
                                {props.headerTitle}
                            </Typography>
                        }
                        onNext={props.onNext}
                        nextIcon={<CloseIcon />}
                    />
                </Header>
            )}
            <div {...bodyProps}>
                <PageTitle>{props.title}</PageTitle>
                {props.titleSecondLine && (
                    <BodyText>{props.titleSecondLine}</BodyText>
                )}
                {props.sealImageSrc && (
                    <SealImage
                        src={props.sealImageSrc}
                        alt="Azarashi illustration"
                    />
                )}
                {props.children}
            </div>

            <ReportFooter {...footerProps}>
                <Layout.Column gap={2}>
                    <div>
                        <Button
                            variant="filled"
                            color="primary"
                            fullWidth
                            onClick={props.next}
                        >
                            {props.primaryButtonLabel}
                        </Button>
                    </div>
                    {props.cancelButtonLabel && props.cancel && (
                        <div>
                            <Button
                                variant="filled"
                                fullWidth
                                onClick={props.cancel}
                                color={
                                    props.cancelErrorColor ? "error" : undefined
                                }
                            >
                                {props.cancelButtonLabel}
                            </Button>
                        </div>
                    )}
                    {props.tertiaryButtonLabel && props.tertiary && (
                        <div>
                            <Button
                                variant="filled"
                                fullWidth
                                onClick={props.tertiary}
                                color={
                                    props.tertiaryErrorColor
                                        ? "error"
                                        : undefined
                                }
                            >
                                {props.tertiaryButtonLabel}
                            </Button>
                        </div>
                    )}
                </Layout.Column>
            </ReportFooter>
        </main>
    )
}
